import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { track } from "../lib/analytics";
import { useLocale } from "../context/LocaleContext";
import { ContentCard } from "../components/ContentCard";
import { Button } from "../components/ui/button";
import Seo from "../components/Seo";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const { locale, t } = useLocale();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    if (!q) return;
    setData(null); setError(false);
    api.get(`/api/public/search?q=${encodeURIComponent(q)}&locale=${locale}`)
      .then(({ data }) => setData(data))
      .catch(() => setError(true));
    track("search", { locale, props: { q } });
  }, [q, locale, reload]);

  return (
    <>
      <Seo title={`${t("search")}: ${q} | LIVYVIO`} description={`${t("resultsFor")} ${q}`} />
      <div className="container-page py-12">
        <h1 className="font-heading text-3xl font-black tracking-tight text-slate-900">
          {t("resultsFor")} “{q}”
        </h1>
        {data && <p className="mt-1 text-sm text-slate-500">{data.total} · {locale.toUpperCase()}</p>}
        <div className="mt-8">
          {!q ? (
            <p className="text-slate-500" data-testid="search-empty">{t("noResults")}</p>
          ) : error ? (
            <div className="flex flex-col items-start gap-3" data-testid="search-error">
              <p className="text-slate-600">{t("loadErrorBody")}</p>
              <Button onClick={() => setReload((n) => n + 1)} data-testid="search-retry" className="rounded-full bg-emerald-600 hover:bg-emerald-700">{t("retry")}</Button>
            </div>
          ) : !data ? (
            <p className="text-slate-400" data-testid="search-loading">{t("loading")}</p>
          ) : data.items.length === 0 ? (
            <p className="text-slate-500" data-testid="search-empty">{t("noResults")}</p>
          ) : (
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {data.items.map((it, i) => <ContentCard key={it.id} item={it} index={i} />)}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
